import { Component, inject, OnInit } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { SessionService } from '../../shared/services/session.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
  imports: [SharedModule],
})
export class LogoutComponent implements OnInit {
  private sessionService = inject(SessionService);
  ngOnInit(): void {
    this.sessionService.logout();
  }
}
